<script setup lang="ts">
import { type BadgeProps, type ButtonProps } from '#ui/types';

// PROPS
interface Props {
    label?: string | number | null;
    color?: BadgeProps['color'];
    size?: ButtonProps['size'];
    variant?: ButtonProps['variant'];
}

const { variant, color = 'white' as BadgeProps['color'], label = null } = defineProps<Props>();

// EMITS
const emit = defineEmits(['delete']);

// DATA
const ui = computed(() => {
    if (variant === 'soft') {
        return { base: `bg-${color}-50 text-${color}-950` };
    }
});
</script>

<template>
    <UBadge :size="size" :color="color" :ui="ui">
        <slot>{{ label }}</slot>
        <UButton icon="lucide:x" class="ml-1 px-0 py-0 text-current" :size="size" variant="ghost" @click="emit('delete')" />
    </UBadge>
</template>
